import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import parse from 'html-react-parser'
import { Container, Row, Col } from '../../../components/ui/wrapper'
import Heading from '../../../components/ui/heading'
import Gradiation from '../../../components/ui/gradiation'
import { GradiationSectionWrap, GradiationRow, SectionTitleWrap, StepWrap } from './GradiationAreaStyles'

const GradiationArea = ({ titleStyle, subtitleStyle }) => {
    const gradiationData = useStaticQuery(graphql`
        query ServicesGradiationQuery {
            servicesJson(jsonId: {eq: "services-gradiation-content"}) {
                title
                subtitle
                gradiations {
                    id
                    title
                    desc
                    path
                }
            }
        }
    `);
    const servicesJson = gradiationData.servicesJson;
    if (!servicesJson) {
        console.warn("GradiationArea: servicesJson is null");
        return null;
    }

    const { title, subtitle, gradiations } = servicesJson;

    // Inline style fallbacks for styled-components hydration issues in dev mode
    const sectionStyle = { paddingTop: '100px', paddingBottom: '91px' };
    const sectionTitleStyle = { marginBottom: '53px' };
    const stepWrapStyle = { textAlign: 'right' };
    const h3Style = {
        position: 'relative',
        fontSize: '13px',
        lineHeight: '2em',
        letterSpacing: '2px',
        textTransform: 'uppercase',
        display: 'inline-block',
        padding: '35px 80px 35px 42px',
        zIndex: 1
    };
    const markStyle = {
        position: 'absolute',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        fontSize: '120px',
        lineHeight: 0.8,
        fontWeight: 900,
        color: '#ededed',
        zIndex: -1,
        backgroundColor: 'transparent'
    };

    return (
        <GradiationSectionWrap style={sectionStyle}>
            <Container>
                <Row>
                    <Col md={6}>
                        <SectionTitleWrap style={sectionTitleStyle}>
                            {subtitle && <Heading {...subtitleStyle}>{subtitle}</Heading>}
                            {title && <Heading {...titleStyle}>{parse(title)}</Heading>}
                        </SectionTitleWrap>
                    </Col>
                    <Col md={6}>
                        <StepWrap style={stepWrapStyle}>
                            <h3 style={h3Style}>
                                <span style={{
                                    backgroundColor: '#4b1e79',
                                    content: '""',
                                    position: 'absolute',
                                    top: '47px',
                                    left: 0,
                                    width: '34px',
                                    height: '1px',
                                    display: 'block'
                                }}></span>
                                <mark style={markStyle}>{`0${gradiations.length}`}</mark>
                                Steps
                            </h3>
                        </StepWrap>
                    </Col>
                </Row>
                <Row>
                    <Col lg={12}>
                        <GradiationRow style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {gradiations.map((gradiation, i) => (
                                <Col lg={3} md={6} key={gradiation.id}>
                                    <Gradiation
                                        number={i + 1}
                                        isLast={i === gradiations.length - 1}
                                        title={gradiation.title}
                                        desc={gradiation.desc}
                                    /* path={gradiation.path} */
                                    />
                                </Col>
                            ))}
                        </GradiationRow>
                    </Col>
                </Row>
            </Container>
        </GradiationSectionWrap>
    )
}

GradiationArea.defaultProps = {
    titleStyle: {
        as: "h4",
        child: {
            color: 'primary'
        }
    },
    subtitleStyle: {
        as: "h6",
        color: "#333",
        fontSize: '14px',
        letterspacing: '3px',
        texttransform: 'uppercase',
        lineHeight: 1.43,
        mt: '-5px',
        mb: '20px'
    }
}

export default GradiationArea
